import { render, staticRenderFns } from "./GFSettlementOnHold.vue?vue&type=template&id=06def502"
import script from "./GFSettlementOnHold.vue?vue&type=script&lang=js"
export * from "./GFSettlementOnHold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports